import { useCallback } from 'react';

import { type GenerationTool } from 'src/data/generationTool';
import { useEffectOnce } from 'src/lib/hooks';
// @ts-expect-error - JS module without type declarations
import { usePopups } from 'src/lib/popups';

import { type SubmitResult, TemplateFoundPopup } from './TemplateFoundPopup';

const POPUP_KEY = Symbol('TEMPLATE_FOUND');

interface OpenPopupParams {
  generationTool?: GenerationTool;
  templateName?: string | null;
}

/**
 * Open the "template found" popup
 */
export const useTemplateFoundPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(POPUP_KEY, TemplateFoundPopup);
  });

  return useCallback(
    (params: OpenPopupParams = {}): Promise<SubmitResult | null> => {
      return new Promise((resolve) => {
        popups.openPopup(POPUP_KEY, {
          ...params,

          onSubmit: (result: SubmitResult) => {
            popups.closePopup(POPUP_KEY);
            resolve(result);
          },
          onClose: () => {
            popups.closePopup(POPUP_KEY);
            resolve(null);
          },
        });
      });
    },
    [popups]
  );
};
